const CONFIG = { key: 'bdn11', tag: '18228' };

export const FAKE_DATA = {
  banner: {
    error: 0,
    errormsg: '',
    data: [
      {
        rank: '1',
        brand: 'Brand 1',
        category: 'Category 1',
        title: 'Title 1',
        desc: 'Desc1',
        rurl: 'https://ww55.affinity.net/sssdomweb?enk=ec51ae22b746861f1753b77415e3180a933de9bf12b4b54c7c887129d9261a8a3f889dd4d208b1c60c8b6a6f8966dca776ca6e70a64c85852c3ff26add3689156c76b6718',
        iurl: 'https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png',
        burl: 'https://static-02.veve.com/banner/83de649a02f345f9.png',
        favico: 'https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png',
        adid: 'adid1',
        impurl:
          'https://imptrk.siteplug.com/impTrk.php?enk1=0466a8d5aee5ffbe3d3979bb1b569bda4a9e1570899fe7e1f0e0746aa4faf833a531784dca1416',
        durl: 'brand1.com',
      },
    ],
  },
  tiles: {
    error: 0,
    errormsg: '',
    data: [
      {
        rank: 1,
        brand: 'Brand 1',
        category: 'category1',
        rurl: 'https://ww55.affinity.net/sssdomweb?enk=4bcad8cbeb87f0c66',
        iurl: 'https://static-02.veve.com/abcde/brand1.png',
        impurl: 'https://imptrk.siteplug.com//impTrk.php?ui=A9999999999',
      },
      {
        rank: 2,
        brand: 'Brand 2',
        category: 'category2',
        rurl: 'https://ww55.affinity.net/sssdomweb?enk=4bcad8cbeb81b2c6c',
        iurl: 'https://static-02.veve.com/abcde/brand2.png',
        impurl: 'https:/ww4.siteplug.com/impTrk.php?ui=A9999999999',
      },
      {
        rank: 3,
        brand: 'Brand 3',
        category: 'category3',
        rurl: 'https://ww55.affinity.net/sssdomweb?enk=4bcad8cbeb87fc9',
        iurl: 'https://static-02.veve.com/abcde/brand3.png',
        impurl: 'https:/imptrk.siteplug.com/om/impTrk.php?ui=A9999999999',
      },
    ],
  },
};

export interface VeveTile {
  rank: string, /// Display order of importance
  brand: string, /// Brand name
  category: string, /// "Category 1",
  rurl: string, /// "https://ww55.affinity.net/sssdomweb?enk=ec51ae22b746861f1753b77415e3180a933de9bf12b4b54c7c887129d9261a8a3f889dd4d208b1c60c8b6a6f8966dca776ca6e70a64c85852c3ff26add3689156c76b6718",
  iurl: string, /// "https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png",
  impurl: string, /// "https://imptrk.siteplug.com/impTrk.php?enk1=0466a8d5aee5ffbe3d3979bb1b569bda4a9e1570899fe7e1f0e0746aa4faf833a531784dca1416",
}

export interface VeveBanner extends VeveTile {
  title: string, /// "Title 1",
  desc: string, /// "Desc1",
  burl: string, /// "https://static-02.veve.com/banner/83de649a02f345f9.png", 300x250
  favico: string, /// "https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png",
  adid: string, /// "adid1",
  durl: string, /// "brand1.com"
}

const fetcher = <T>(url: string): Promise<T[]> => fetch(url)
  .then((res) => res.json())
  .then(({ data }) => data)
  .catch((err) => {
    console.error('bannerPromise', err);
    return [];
  });

type TilesOrBanners<T> = T extends { itype: string }
  ? VeveTile
  : VeveBanner;

export const fetchAffinity = <T>(userId, params: T): Promise<TilesOrBanners<T>[]> => {
  const url = `https://${CONFIG.key}.veve.com/qlapi?${new URLSearchParams({
    o: CONFIG.key,
    s: CONFIG.tag,
    u: 'oceanhero.today',
    f: 'json',
    di: userId,
    ...params,
  })}`;

  return fetcher<TilesOrBanners<T>>(url);
};

